import { UserDto } from '@sr/dto';
import { fetchCollectionReq } from 'shared/api/axios';

export const fetchManagersDropdown = async (scope?: 'events') => {
  return fetchCollectionReq<UserDto>(
    scope === 'events' ? '/events/manager-dropdown' : '/users/dropdown',
    UserDto
  );
};